(() => {
  const body = document.body;
  if (!body.classList.contains('template-index')) return;
  const hero = document.querySelector('#MainContent .section-slideshow');
  if (!hero || !('IntersectionObserver' in window)) {
    body.classList.add('verner-hero-cleared');
    return;
  }
  const observer = new IntersectionObserver(([entry]) => {
    body.classList.toggle('verner-hero-cleared', !entry.isIntersecting);
  }, { threshold: 0 });
  observer.observe(hero);
})();
